import { FC, ReactNode } from "react";
import { useSelector } from "react-redux";
import clsx from "clsx";

import CriteriasPopup from "../custom/criteriasPopup/criteriasPopup";
import GroupBtn from "../groupBtn/groupBtn";

import "../../scss/App.scss";

interface ISectionContentProps {
  headBlockFilters?: ReactNode;
  buttonsContainerRef?: React.RefObject<HTMLDivElement> | null;
  isOpenGroupBtn?: boolean;
  headBlockChildren?: ReactNode;
  availableButtons?: ReactNode[];
  children?: ReactNode;
  pageName?: string;
  section?: string;
  title?: string;
  root?: string;
  tail?: string;
}

const IS_VISIBLE_SIDEBAR = process.env.REACT_APP_IS_VISIBLE_SIDEBAR;

const SectionContent: FC<ISectionContentProps> = ({
  root = "Merch Online",
  buttonsContainerRef,
  headBlockChildren,
  headBlockFilters,
  availableButtons,
  isOpenGroupBtn,
  pageName,
  children,
  section,
  title,
  tail,
}) => {
  const { data, isOpenSidebar } = useSelector((state: any) => state.user.user);

  const handleClickBreadCrumbs = (title: string) => {
    const url = window.location.href;
    const urlObject = new URL(url);
    const path = urlObject.pathname;
    const pathSegments = path.split("/");
    if (title === "section") {
      if (
        pageName === "clientSettings" ||
        pageName === "clientInfo" ||
        pageName === "accessRights" ||
        pageName === "recruitingSingle"
      ) {
        window.location.href = `/${pathSegments[1]}/${pathSegments[2]}`;
      } else {
        window.location.href = `/${pathSegments[1]}`;
      }
    } else {
      if (pageName === "clientSettings") {
        window.location.href = `/${pathSegments[1]}/${pathSegments[2]}/info/${pathSegments[4]}`;
      } else {
        window.location.href = `/${pathSegments[1]}/${pathSegments[2]}`;
      }
    }
  };

  return (
    <div className="content" style={{ marginLeft: 0 }}>
      <div
        className={clsx(
          JSON.parse(IS_VISIBLE_SIDEBAR as string) &&
            isOpenSidebar &&
            "active__head_block",
          !isOpenSidebar && "closed__head_block",
          "head__block"
        )}
      >
        <div className="head_block_left">
          <div
            className={
              isOpenGroupBtn ? "active__block_children" : "head__block_children"
            }
            ref={buttonsContainerRef}
          >
            {headBlockChildren}
          </div>
          {isOpenGroupBtn && <GroupBtn children={availableButtons} />}
          <div className="head__block_filters">{headBlockFilters}</div>
        </div>
      </div>
      <div className="content__title">
        <div
          className={clsx(
            JSON.parse(IS_VISIBLE_SIDEBAR as string) &&
              isOpenSidebar &&
              "breadcrumbs_active",
            !isOpenSidebar && "breadcrumbs_close",
            "breadcrumbs"
          )}
        >
          <span onClick={() => (window.location.href = "/")}>{root}</span>{" "}
          <span
            onClick={() => {
              handleClickBreadCrumbs("section");
            }}
            style={{
              cursor:
                !pageName || !title || pageName === "vacancy"
                  ? "auto"
                  : "pointer",
            }}
          >
            {section}
          </span>
          {pageName !== "reports" &&
            pageName !== "unloadings" &&
            pageName !== "notFound" && (
              <span
                onClick={() => {
                  handleClickBreadCrumbs("title");
                }}
              >
                {title}
              </span>
            )}{" "}
          {(pageName === "reportSignals" ||
            pageName === "clientSettings" ||
            pageName === "recruitingSingle") && <span>{tail}</span>}
        </div>
        {pageName === "report" &&
          data &&
          !data.isCustomer &&
          (data.claims.includes("admin") ||
            data.claims.includes("reports:review:create")) && (
            <CriteriasPopup />
          )}
      </div>
      {children}
    </div>
  );
};

export default SectionContent;
